function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.012)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.844,5.965,47.875,5A.732.732,0,0,0,46.84,6.032L47.808,7a2.523,2.523,0,0,1,0,3.564L46.473,11.9,38.111,3.538,39.446,2.2a2.523,2.523,0,0,1,3.564,0L44.428,3.62a.732.732,0,0,0,1.036-1.036L44.046,1.167a3.985,3.985,0,0,0-5.636,0L9.061,30.516A.732.732,0,0,0,10.1,31.552L33.848,7.8l3.663,3.663L7.39,41.585,5,40.51a.387.387,0,0,1-.195-.194L3.727,37.922l3.966-3.966a.732.732,0,0,0-1.036-1.036L2.322,37.257a1.36,1.36,0,0,0-.26.733L.033,48.581a1.194,1.194,0,0,0,1.4,1.4l10.959-2.1a.789.789,0,0,0,.36-.184L48.844,11.6a3.99,3.99,0,0,0,0-5.636ZM2.055,45.809l.039-.2,2.313,2.313-.011,0-2.85.546Zm4.09,1.775L2.428,43.866l.707-3.688.332.738a1.85,1.85,0,0,0,.93.93L7,43.014l1.169,2.6a1.85,1.85,0,0,0,.93.93l.739.332Zm5.944-1.3L9.7,45.209a.387.387,0,0,1-.195-.195L8.426,42.621,38.547,12.5l3.663,3.663ZM43.246,15.128,34.883,6.766l2.192-2.192,8.362,8.362Z",
  transform: "translate(0)"
}));

function SvgEditar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.998,
    height: 50,
    viewBox: "0 0 49.998 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.0e15ab42.svg";
export { ForwardRef as ReactComponent };